import React from "react";
import {Box} from "@material-ui/core";
import {Skeleton} from "@material-ui/lab";
import {makeStyles} from "@material-ui/core/styles";
import MinimalLoader from "./MinimalLoader";

const useStyles = makeStyles((theme) => ({
    root: {
        margin: theme.spacing(3, 0, 4),
    },
    status: {
        marginBottom: theme.spacing(2.5),
    },
    line: {
        height: 22,
        marginBottom: theme.spacing(1.25),
        transform: "none",
        borderRadius: 6,
    },
    paragraph: {
        marginBottom: theme.spacing(3),
    },
    image: {
        height: 420,
        borderRadius: theme.spacing(2),
        [theme.breakpoints.down("xs")]: {
            height: 300,
        },
    },
}));

const PARAGRAPHS = [[100, 97, 99, 94, 62], [98, 100, 95, 41]];

// Stands in for the scene being written, and for the whole story while it loads
export default function PlaceholderStoryCard({label = "Writing the next scene", withImage = false}: {
    label?: string,
    withImage?: boolean
}) {
    const classes = useStyles();

    return (
        <Box className={classes.root} aria-busy="true" aria-live="polite">
            <Box className={classes.status}>
                <MinimalLoader label={label}/>
            </Box>
            {PARAGRAPHS.map((widths, index) => (
                <Box key={index} className={classes.paragraph}>
                    {widths.map((width, line) => (
                        <Skeleton key={line} variant="text" animation="wave" className={classes.line}
                                  style={{width: `${width}%`}}/>
                    ))}
                </Box>
            ))}
            {withImage && <Skeleton variant="rect" animation="wave" className={classes.image}/>}
        </Box>
    );
}
